/**
* Created by lobin on 2020/7/14.
*/
<template>
  <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
    <a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
      <a-form-model-item>
				<company-search
					v-model="search.company"
					placeholder="请选择所属公司"
				/>
			</a-form-model-item>
			<a-form-model-item>
				<a-input v-model="search.nickname" placeholder="输入微信昵称" allowClear></a-input>
			</a-form-model-item>
			<a-form-model-item>
				<a-input v-model="search.mobile" placeholder="输入电话" allowClear></a-input>
			</a-form-model-item>
			<a-form-model-item>
				<a-range-picker
					valueFormat="YYYY-MM-DD"
					v-model="searchRange"
				/>
			</a-form-model-item>
			<a-form-model-item>
				<a-button
					type="primary"
					html-type="submit"
					icon="search"
				>
					查询
				</a-button>
			</a-form-model-item>
		</a-form-model>
		<a-divider />
		<a-table
			:loading="listloading"
			:columns="columns"
			:data-source="list"
			:scroll="{y: 500 }"
			:pagination="pager"
			@change="change">
			<span slot="user" slot-scope="text, record">
          <a-avatar :src="record.headimgurl" />
          <span style="margin-left: 10px">{{ record.nickname }}</span>
			</span>
			<span slot="subscribe" slot-scope="text">
				<a-tag color="#87d068" v-if="text === 1">已关注</a-tag>
				<a-tag color="#f50" v-else>未关注</a-tag>
			</span>
			<span slot="action" slot-scope="text, record">
        <a @click="playAudio(record._id)">播放</a>
        <a-divider type="vertical" />
				<a @click="unbind(record._id)">解绑手机</a>
			</span>
		</a-table>
	</a-card>
</template>

<script type="text/babel">
import { voiceList, createVoice, voiceDetail } from '@/api/voice';
import { base64ToBlob } from '../../utils/index';

export default {
  data() {
    return {
      listloading: false,
      list: [],
      pager: {},
      search: {},
      searchRange: [],
    };
  },
  created() {
    this.getList();
  },
  computed: {
    columns() {
      return [
	      {
		      title: '#',
		      dataIndex: 'index',
		      customRender: (text, row, index) => index + 1,
		      key: 'index',
		      width: '50px',
	      },
        {
          title: '内容',
          dataIndex: 'text',
          key: 'text',
        },
        {
          title: 'Key',
          dataIndex: 'key',
          key: 'key',
        },
        {
          title: '类型',
          dataIndex: 'type',
          key: 'type',
        },
        {
          title: '格子编号',
          dataIndex: 'cabSerial',
          key: 'cabSerial',
        },
	      {
		      title: '操作',
		      key: 'action',
		      fixed: 'right',
		      width: 142,
		      scopedSlots: { customRender: 'action' },
	      },
      ];
    },
  },
  methods: {
    async getList() {
      this.listloading = true;
      const q = { ...this.search };
      // eslint-disable-next-line prefer-destructuring
      q.start = this.searchRange[0];
      // eslint-disable-next-line prefer-destructuring
      q.end = this.searchRange[1];
      try {
        const { data: { docs, pager } } = await voiceList(q);
        this.list = docs;
        this.pager = {
	        ...pager,
	        showTotal: (total) => `共计 ${total} 条信息`,
        };
      } catch (e) {
        console.error(e);
      }
      this.listloading = false;
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    handleSearch() {
      this.getList();
    },
    async playAudio(id) {
      const { data } = await voiceDetail(id);
      console.log(data);
      const audioBlob = base64ToBlob(data.audio, 'wav');
      const url = window.URL.createObjectURL(audioBlob);
      console.log(url);
      this.play(url);
    },
    async play(src) {
      const audio = new Audio(src);
      audio.play();
    },
	  async unbind(id) {
    	await unbinMobile(id);
    	this.$message.success('操作成功');
	    this.getList();
	  },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.user-list {

	}
</style>
